import { apiCMSWithToken } from './axios'
import { apiBaseCMSWithToken } from './axiosBase'
import { apiLandingCMSWithToken } from './axiosLanding'

export const url = {
  pakages: `/pakages`
}

export async function getPakagePost(p = {}) {
  try {
    const params = new URLSearchParams({ ...p })
    const response = await apiCMSWithToken.get(
      `${url.pakages}?${params.toString()}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function pakagePostAdd(body) {
  const response = await apiCMSWithToken.post(`${url.pakages}`, body)
  return response
}

export async function pakagePostUpdate(body, id) {
  const response = await apiCMSWithToken.put(`${url.pakages}/${id}`, body)
  return response
}

export async function pakagePostDetail(id) {
  try {
    const response = await apiCMSWithToken.get(`${url.pakages}/${id}`)

    return response
  } catch (error) {
    console.error('Error in issueSearch:', error)
    throw error
  }
}

export async function deletePakagePost(id) {
  try {
    const response = await apiCMSWithToken.delete(`${url.pakages}/${id}`)
    // const response = await apiCMSWithToken.delete(`${url.pakages}`, {
    //   data: body
    // })
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

//History

export async function getPakageHistoryPost(p = {}) {
  try {
    const params = new URLSearchParams({ ...p })
    const response = await apiCMSWithToken.get(
      `${url.pakages}/history-buy-package-web?${params.toString()}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function getPakagePostNew(p = {}) {
  try {
    const params = new URLSearchParams({ ...p })
    const response = await apiLandingCMSWithToken.get(
      `/config-packages-fee-web/find-all?${params.toString()}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function pakagePostAddNew(body) {
  const response = await apiLandingCMSWithToken.post(
    `/config-packages-fee-web/create`,
    body
  )
  return response
}

export async function pakagePostUpdateNew(body) {
  const response = await apiLandingCMSWithToken.put(
    `/config-packages-fee-web/update`,
    body
  )
  return response
}

export async function pakagePostDetailNew(id) {
  try {
    const response = await apiLandingCMSWithToken.get(
      `/config-packages-fee-web/detail/${id}`
    )
    return response
  } catch (error) {
    console.error('Error in pakagePostDetailNew:', error)
    throw error
  }
}

export async function deletePakagePostNew(id) {
  try {
    const response = await apiLandingCMSWithToken.delete(
      `/config-packages-fee-web/delete/${id}`
    )
    return response
  } catch (error) {
    console.error('Error in deletePakagePostNew:', error)
    throw error
  }
}
export async function getPackageListFeeWeb(
  propertyType,
  demand,
  typeRealState
) {
  try {
    const params = {
      propertyType: propertyType,
      demand: demand,
      typeRealState: typeRealState
    }
    const response = await apiBaseCMSWithToken.get(
      `/landing/v1/public/api/config-packages-fee-web/find-by-property-type-demand-typerealstate`,
      { params, tokenKey: 'tokenWeb' }
    )
    return response
  } catch (error) {
    console.error('Error fetching posts:', error)
    throw error
  }
}

export default {
  getPakagePost,
  pakagePostAdd,
  pakagePostUpdate,
  pakagePostDetail,
  deletePakagePost,
  // pakagePostAdd,
  getPakageHistoryPost,
  getPakagePostNew,
  pakagePostAddNew,
  pakagePostUpdateNew,
  pakagePostDetailNew,
  deletePakagePostNew,
  getPackageListFeeWeb
  // pakagePostUpdate,
  // pakagePostDetail,
  // deleteItemPakge,
  // getPakagePostHistory
}
